import styles from './error-widget.module.scss'
import common from '../../registration-code.module.scss'

const ErrorWidget = () => {
  return (
    <div className={common.wrapperCommon}>
      <div className={common.title}>Что-то пошло не так</div>
      <div className={styles.subtitle}>
        Обратитесь в поддержку <span>info@medpoint.pro</span>
      </div>
    </div>
  )
}

export default ErrorWidget
